import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../utils/api';
import './ResetPassword.css';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { token, role } = useParams(); // role will be 'patient' or 'doctor'

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    try {
      const endpoint = role === 'patient' ? '/auth/patient/reset-password' : '/auth/doctor/reset-password';
      const response = await api.post(endpoint, { token, password }, { headers: { 'No-Auth': true } });
      setMessage(response.data.message);
      setTimeout(() => {
        if (role === 'patient') {
          navigate('/login?type=patient');
        } else if (role === 'doctor') {
          navigate('/doctor-login');
        }
      }, 2000);
    } catch (error) {
      console.error('Reset password error:', error.response?.data);
      setError(error.response?.data?.error || 'Something went wrong.');
    }
  };

  return (
    <div className="reset-password-page">
      <div className="auth-container">
        <h2>Reset Password ({role.charAt(0).toUpperCase() + role.slice(1)})</h2>
        {message && <p className="success-message">{message}</p>}
        {error && <p className="error-message">{error}</p>}
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder="New Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="new-password" // Added for accessibility
          />
          <input
            type="password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="new-password" // Added for accessibility
          />
          <button type="submit">Reset Password</button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;